import { Icons } from '@/theme/Images'
import PropTypes from 'prop-types'

const Checkbox = ({ isChecked, onClick }) => (
  <div className="mr-3 cursor-pointer" onClick={onClick}>
    {isChecked ? (
      <img src={Icons.checkboxCheckedIcon} alt="Checkbox" className="h-5 w-6" />
    ) : (
      <img src={Icons.checkboxUncheckedIcon} alt="Checkbox" className="h-5 w-6" />
    )}
  </div>
)

Checkbox.propTypes = {
  isChecked: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
}

export default Checkbox
